<template>
  <div>
    <v-card
      v-if="locacao.estado_locacao.id === 'aprovacao'"
      style="border-left: 5px solid orange"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-icon color="warning" left>mdi-alert</v-icon> Pendente aprovação
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions>
        <v-btn
          @click="reprovar()"
          :loading="reprovando"
          small
          color="primary"
          outlined
        >
          <v-icon small left>mdi-thumb-down</v-icon> Desaprovar
        </v-btn>
        <v-btn
          @click="aprovar()"
          :loading="aprovando"
          small
          color="primary"
          outlined
        >
          <v-icon small left>mdi-thumb-up</v-icon> Aprovar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-else-if="locacao.aprovacao === true"
      style="border-left: 5px solid green"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-icon color="green" left>mdi-check</v-icon> Aprovado
          </v-list-item-title>
          <v-list-item-subtitle>
            Responsável: {{ locacao.aprovado_por.name }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            Data: {{ locacao.aprovado_as }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <v-card
      v-else-if="locacao.aprovacao === false"
      style="border-left: 5px solid red"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-icon color="red" left>mdi-close</v-icon> Reprovado
          </v-list-item-title>
          <v-list-item-subtitle>
            Responsável: {{ locacao.aprovado_por.name }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            Data: {{ locacao.aprovado_as }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import api from "@/services/locacoes.js";

export default {
  mixins: [],

  components: {},

  props: {
    locacao: Object
  },

  data() {
    return {
      aprovando: false,
      reprovando: false
    };
  },

  methods: {
    async aprovar() {
      this.aprovando = true;

      try {
        const response = await api.locacoes.aprovar(this.locacao.codigo);

        this.$emit("aprovado", response);
      } catch (error) {
        console.error(error);
      } finally {
        this.aprovando = false;
      }
    },

    async reprovar() {
      this.reprovando = true;

      try {
        const response = await api.locacoes.reprovar(this.locacao.codigo);

        this.$emit("reprovado", response);
      } catch (error) {
        console.error(error);
      } finally {
        this.reprovando = false;
      }
    }
  },

  computed: {}
};
</script>
